export default __webpack_public_path__ + "static/media/WOR-designsystem.b4aff3bb.png";